import React from 'react';

import IconButton from '@material-ui/core/IconButton';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

import { t } from '../../../providers/TranslationProvider';

const useStyles = makeStyles((theme) => ({
    infoCard: {
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'start',
        width: '100%',
        padding: '16px 10px',
        boxShadow: '0px 3px 3px -2px rgba(0, 0, 0, 0.2), 0px 3px 4px rgba(0, 0, 0, 0.14), 0px 1px 8px rgba(0, 0, 0, 0.12)',
        borderRadius: '4px',
        marginBottom: '12px',
        '@media (max-width:660px)': {
            width: 'auto',
        },
    },
    infoIcon: {
        padding: '4px 15.67px 0px 15.67px',
    },
    info: {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
    },
    infoTitle: {
        fontSize: theme.typography.fontSize,
        color: '#3D1B0A',
        letterSpacing: '-0.2px',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'baseline',
        paddingRight: '5.61px',
    },
    subInfoAction: {
        fontSize: '0.75rem',
        color: '#5D5D5D',
        lineHeight: '133%',
        margin: '8px 0px 0px 0px',
        width: '90%',
    },
    action: {
        display: 'flex',
        alignItems: 'center',
    },
    closeBtn: {
        '&:focus-visible': {
            backgroundColor: 'rgba(209, 224, 194, 0.2)',
            outline: 'none',
            border: '2px dashed #4F7E1D',
            borderRadius: '3px',
        },
    },
    actionIcon: {
        paddingLeft: '6.68px',
    },
}));

const InfoMessage = ({ infoIcon, title, subtitle, closeIcon, infoStyle = {}, action }) => {
    const classes = useStyles();
    const InfoIconComponent = infoIcon;
    const CloseIconComponent = closeIcon;
    return (
        <React.Fragment>
            <div className={classes.infoCard} style={infoStyle}>
                <div className={classes.infoIcon}>
                    <InfoIconComponent />
                </div>
                <div className={classes.info}>
                    <div className={classes.infoTitle}>
                        <Typography style={{ color: '#162655' }}>{title}</Typography>
                        <div className={classes.infoAction}>
                            <IconButton
                                disableFocusRipple
                                className={classes.closeBtn}
                                onClick={action}
                                style={{ padding: 'unset' }}
                                aria-label={t('close.info.banner')}>
                                <CloseIconComponent className={classes.actionIcon} focusable="false" aria-hidden="true" />
                            </IconButton>
                        </div>
                    </div>
                    <span className={classes.subInfoAction}>{subtitle}</span>
                </div>
            </div>
        </React.Fragment>
    );
};

export default InfoMessage;
